import React, { createContext, useReducer, useState } from "react";

export const GlobalContext = createContext({});

const GlobalProvider = ({ children }) => {
  const [availableStore, setAvailableStore] = useState(0);

  return (
    <GlobalContext.Provider
      value={{
        availableStore,
        setAvailableStore,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalProvider;
